export const IconList = ({ isActive = false }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="2"
        fill={isActive ? "#323133" : "#BDBDBD"}
      />
      <rect
        x="3"
        y="11"
        width="18"
        height="2"
        fill={isActive ? "#323133" : "#BDBDBD"}
      />
      <rect
        x="3"
        y="17"
        width="18"
        height="2"
        fill={isActive ? "#323133" : "#BDBDBD"}
      />
    </svg>
  );
};
